// Enlaces.js
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { sizes } from '../utils/breakpoints'

const Enlaces = styled(Link)`
  font-size: 14px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.85);
  font-family: ${({ theme }) => theme.fonts.accentRegular};
  text-decoration: none;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.7;
    text-decoration: underline;
  }

  @media (max-width: ${sizes.mobile}px) {
    font-size: 12px;
  }
`

export default Enlaces
